angular.module('app.directives').directive('customilyColorPicker', function () {
    return {
        restrict: 'E',
        scope: {
            onChange: '&',
            onSave: '&',
            onReady: '&',
            ctrlMethods: '=',
            colorMode: '=',
            alpha: '=',
            disableSave: '=',
            disabled: '='
        },
        template: require('./customilyColorPicker.html'),
        controller: function ($scope, $element, $attrs, $timeout) {
            $timeout(() => {
                var input = $element.find('input');
                var lastColor = input.attr('value').replace('#', '');
                var lastAlpha = 1;
                var colorPickerObj = null;
                var initialized = false;

                var rgba2hex = function (orig) {
                    var a,
                        rgb = (rgb = orig
                            .replace(/\s/g, '')
                            .match(/^rgba?\((\d*\.?\d+),(\d*\.?\d+),(\d*\.?\d+),?([^,\s)]+)?/i)),
                        alpha = ((rgb && rgb[4]) || '').trim(),
                        hex = rgb
                            ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
                              (rgb[2] | (1 << 8)).toString(16).slice(1) +
                              (rgb[3] | (1 << 8)).toString(16).slice(1)
                            : orig;

                    if (alpha !== '') {
                        a = alpha;
                    } else {
                        a = 1;
                    }

                    return {
                        hex: hex,
                        alpha: parseFloat(a)
                    };
                };

                if ($scope.ctrlMethods) {
                    /**
                     * Close the color picker and call onChange() one last time with the last saved color
                     */
                    $scope.ctrlMethods.terminate = function () {
                        if (colorPickerObj && lastColor) {
                            // Restore the color to the color picker and call the render function manually to update the color
                            colorPickerObj.setColor(lastColor, 'HEX', lastAlpha);
                            colorPickerObj.color.options.renderCallback(
                                colorPickerObj.color.colors,
                                colorPickerObj.color.options.mode,
                                false
                            );

                            // Last color was already applied, don't use it anymore on subsequent calls
                            lastColor = null;

                            if ($scope.onChange && $scope.onChange()) {
                                $scope.onChange()(colorPickerObj.color.colors, true);
                            }
                        }
                    };

                    $scope.ctrlMethods.setColor = function (color) {
                        if (colorPickerObj) {
                            // Old products only have a HEX or RGBA string as color
                            if (typeof color === 'string') {
                                // RGB or RGBA color
                                if (color.indexOf('rgb') === 0) {
                                    var rgb = rgba2hex(color);
                                    colorPickerObj.setColor(rgb.hex, 'HEX', rgb.alpha);
                                }
                                // HEX string
                                else {
                                    colorPickerObj.setColor(color, 'HEX', 1);
                                }
                            }
                            // New products can have RGB or CMYK colors stored as objects
                            else {
                                // This should be the color object from the color picker
                                if (color.rgb && color.HEX) {
                                    // Set the color in CMYK mode if that's the current mode (if we set and RGB color the conversion
                                    //  to CMYK may not be exact resulting in a different color than the user wanted)
                                    if ($scope.colorMode === 'cmyk') {
                                        colorPickerObj.setColor(
                                            {
                                                c: color.cmyk.c * 100,
                                                m: color.cmyk.m * 100,
                                                y: color.cmyk.y * 100,
                                                k: color.cmyk.k * 100
                                            },
                                            'cmyk',
                                            color.alpha
                                        );
                                    }
                                    // Default to RGB if not CMYK
                                    else {
                                        colorPickerObj.setColor('#' + color.HEX, 'HEX', color.alpha);
                                    }
                                }
                                // Object color stored in the database
                                else {
                                    if ($scope.colorMode === 'cmyk') {
                                        var components = color.cmyk.split(',');
                                        colorPickerObj.setColor(
                                            {
                                                c: components[0] * 100,
                                                m: components[1] * 100,
                                                y: components[2] * 100,
                                                k: components[3] * 100
                                            },
                                            'cmyk',
                                            color.alpha
                                        );
                                    } else {
                                        colorPickerObj.setColor(color.hex, 'HEX', color.alpha);
                                    }
                                }
                            }

                            // Call the render function manually to update the color
                            colorPickerObj.color.options.renderCallback(
                                colorPickerObj.color.colors,
                                colorPickerObj.color.options.mode,
                                false
                            );

                            if ($scope.onChange && $scope.onChange()) {
                                $scope.onChange()(colorPickerObj.color.colors);
                            }
                        }
                    };

                    $scope.ctrlMethods.getColor = function (type) {
                        return colorPickerObj.color.getColor(type);
                    };

                    $scope.ctrlMethods.disable = function () {
                        input.prop('disabled', true);
                    };

                    $scope.ctrlMethods.enable = function () {
                        input.prop('disabled', false);
                    };

                    $scope.ctrlMethods.getColors = function () {
                        return colorPickerObj.color.colors;
                    };

                    $scope.ctrlMethods.destroy = function () {
                        colorPickerObj.destroy();
                        colorPickerObj = null;
                    };

                    $scope.ctrlMethods.open = function (position) {
                        var $el = $(colorPickerObj.nodes.colorPicker);
                        $el.css({
                            position: 'absolute',
                            left: position.left,
                            top: position.top
                        });
                        $el.show(200);
                    };

                    $scope.ctrlMethods.openInContainer = function (container) {
                        var $el = $(colorPickerObj.nodes.colorPicker);
                        $el.appendTo(container);
                    };

                    $scope.ctrlMethods.close = function () {
                        $(colorPickerObj.nodes.colorPicker).hide(200);
                    };

                    $scope.ctrlMethods.getDOM = function () {
                        return colorPickerObj.nodes.colorPicker;
                    };
                }

                input.css({
                    padding: '.5em',
                    'margin-right': '.4em',
                    border: '1px solid #aaa',
                    'border-radius': '3px',
                    width: '100%'
                });

                $scope.alpha = typeof $scope.alpha === 'undefined' ? true : $scope.alpha;
                $scope.disableSave = typeof $scope.disableSave === 'undefined' ? false : $scope.disableSave;

                input.colorPicker({
                    multipleInstances: true,
                    customBG: '#222',
                    readOnly: true,
                    size: 4,
                    mode: 'hsv-h',
                    draggable: false,
                    noResize: true,
                    noAlpha: !$scope.alpha,
                    noHexButton: true,
                    noRGBr: true,
                    noRGBg: true,
                    noRGBb: true,
                    convertCallback: function (colors, type) {
                        colors.colorMode = $scope.colorMode;
                    },
                    // colors is a different instance (not connected to colorPicker)
                    init: function (elm, colors, picker) {
                        elm.style.backgroundColor = elm.value;
                        elm.style.color = 'transparent';
                        colorPickerObj = picker;
                        initialized = true;
                    },
                    // Code taken from jqColor.js because we can't attach to the renderCallback, we can only overwrite it.
                    // Slightly modified to our needs.
                    renderCallback: function (colors, mode, runCallbacks) {
                        var options = this,
                            $input = $(options.input),
                            $patch = $(options.patch),
                            AHEX = options.isIE8
                                ? (colors.alpha < 0.16 ? '0' : '') +
                                  Math.round(colors.alpha * 100)
                                      .toString(16)
                                      .toUpperCase() +
                                  colors.HEX
                                : '',
                            isAlpha = colors.alpha !== 1 && !options.isIE8,
                            colorMode = $input.data('colorMode');

                        if (!options._instance) return;

                        $patch.css({
                            color: 'transparent',
                            'background-color': options._instance.toString(),
                            filter: options.isIE8
                                ? 'progid:DXImageTransform.Microsoft.gradient(' + // IE<9
                                  'startColorstr=#' +
                                  AHEX +
                                  ',' +
                                  'endColorstr=#' +
                                  AHEX +
                                  ')'
                                : ''
                        });

                        $input.val(
                            colorMode === 'HEX' && !isAlpha
                                ? '#' + (options.isIE8 ? AHEX : colors.HEX)
                                : options._instance.toString(colorMode, options.forceAlpha)
                        );

                        if (options.displayCallback) {
                            options.displayCallback(colors, mode, options);
                        }

                        // By default, run callbacks
                        if (typeof runCallbacks === 'undefined') {
                            runCallbacks = true;
                        }

                        // Execute callback
                        if (
                            runCallbacks &&
                            $scope.onChange &&
                            $scope.onChange() &&
                            initialized &&
                            colorPickerObj &&
                            $(colorPickerObj.nodes.colorPicker).is(':visible')
                        ) {
                            $scope.onChange()(colors);
                        }
                    },
                    onShow: function (colorPicker) {
                        colorPickerObj = colorPicker;

                        // Save the current color so we can restore it in case it's not saved
                        lastColor = colorPicker.color.colors.HEX;
                        lastAlpha = colorPicker.color.colors.alpha;

                        // Set the picker color
                        if ($scope.colorMode === 'cmyk') {
                            colorPicker.setColor(
                                {
                                    c: colorPicker.color.colors.cmyk.c * 100,
                                    m: colorPicker.color.colors.cmyk.m * 100,
                                    y: colorPicker.color.colors.cmyk.y * 100,
                                    k: colorPicker.color.colors.cmyk.k * 100
                                },
                                'cmyk',
                                colorPicker.color.colors.alpha,
                                true
                            );
                        } else {
                            colorPicker.setColor(
                                '#' + colorPicker.color.colors.HEX,
                                'cmyk',
                                colorPicker.color.colors.alpha,
                                true
                            );
                        }
                        colorPicker.saveAsBackground();
                        colorPicker.color.options.renderCallback(
                            colorPicker.color.colors,
                            colorPicker.color.options.mode,
                            false
                        );

                        // Picker was being cut off by the viewport.
                        
                        var $el = $(colorPicker.nodes.colorPicker);
                        var $input = $element.find('input');
                        var inputOffset = $input.offset();
                        
                        $el.css({
                            position: 'fixed',
                            left: (inputOffset.left - 300) + 'px', // 300px to the left of input
                            top: (inputOffset.top - 300) + 'px',
                            zIndex: 9999
                        });
                        
                        if (
                            $scope.onChange &&
                            $scope.onChange() &&
                            colorPickerObj &&
                            $(colorPickerObj.nodes.colorPicker).is(':visible')
                        ) {
                            $scope.onChange()(colorPicker.color.colors);
                        }
                    },
                    onHide: function (colorPicker) {},
                    onSave: function (colorPicker) {
                        // Save the new color so we don't end up restoring the wrong one
                        lastColor = colorPicker.color.colors.HEX;
                        lastAlpha = colorPicker.color.colors.alpha;

                        if ($scope.onSave && colorPickerObj) {
                            $scope.onSave()(colorPicker.color.colors);
                        }

                        $(colorPicker.nodes.colorPicker).hide(200);
                    }
                });

                // Disable RGB buttons
                window.addEventListener('keydown', (event) => {
                    // If enter key was pressed on the color picker, run the save action
                    if (event.key === 'Enter' && event.target === input.get(0)) {
                        $(colorPickerObj.nodes.colorPicker).find('.cp-bsav').click();
                        input.get(0).blur();
                    }
                });

                var rgbPanel = $(colorPickerObj.nodes.rgb);
                rgbPanel.find('.rgb-r-butt').css('pointer-events', 'none');
                rgbPanel.find('.rgb-r-labl').css('opacity', 0).css('pointer-events', 'none');
                rgbPanel.find('.rgb-g-butt').css('pointer-events', 'none');
                rgbPanel.find('.rgb-g-labl').css('opacity', 0).css('pointer-events', 'none');
                rgbPanel.find('.rgb-b-butt').css('pointer-events', 'none');
                rgbPanel.find('.rgb-b-labl').css('opacity', 0).css('pointer-events', 'none');

                // Disable extra panels
                $(colorPickerObj.nodes.Lab_mode).addClass('cp-hide');
                $(colorPickerObj.nodes.hsl_mode).addClass('cp-hide');
                $(colorPickerObj.nodes.hsv).addClass('cp-hide');
                $(colorPickerObj.nodes.memo).css('display', 'none');
                $(colorPickerObj.nodes.alpha).find('.alpha-labl').css('opacity', 0).css('pointer-events', 'none');
                $(colorPickerObj.nodes.HEX).find('.HEX-labl').css('opacity', 0).css('pointer-events', 'none');
                $(colorPickerObj.nodes.col1).addClass('cp-hide');
                $(colorPickerObj.nodes.col2).addClass('cp-hide');

                if ($scope.alpha) {
                    // Custom styling to make the picker look good with memory colors hidden
                    $(colorPickerObj.nodes.colorPicker).css('height', '300px');
                    $(colorPickerObj.nodes.panel).css('height', '279px');
                    $(colorPickerObj.nodes.opacity).css('bottom', '15px');
                } else {
                    $(colorPickerObj.nodes.colorPicker).css('height', '280px');
                    $(colorPickerObj.nodes.panel).css('height', '255px');
                }

                if ($scope.disableSave) {
                    $(colorPickerObj.nodes.bsav).addClass('cp-hide');
                } else {
                    $(colorPickerObj.nodes.bsav).removeClass('cp-hide');
                }

                // Remove lab buttons
                var cmykPanel = $(colorPickerObj.nodes.cmyk);
                cmykPanel.find('.Lab-L-labl').css({
                    opacity: 0,
                    'pointer-events': 'none'
                });
                cmykPanel.find('.Lab-a-labl').css({
                    opacity: 0,
                    'pointer-events': 'none'
                });
                cmykPanel.find('.Lab-b-labl').css({
                    opacity: 0,
                    'pointer-events': 'none'
                });
                cmykPanel.find('.Lab-x-labl').css({
                    opacity: 0,
                    'pointer-events': 'none'
                });

                $scope.$watch('colorMode', function (newVal) {
                    switch (newVal) {
                        case 'rgb': {
                            $(colorPickerObj.nodes.rgb).removeClass('cp-hide');
                            $(colorPickerObj.nodes.HEX).removeClass('cp-hide');
                            $(colorPickerObj.nodes.cmyk).addClass('cp-hide');
                            break;
                        }
                        case 'cmyk': {
                            $(colorPickerObj.nodes.cmyk).removeClass('cp-hide');
                            $(colorPickerObj.nodes.rgb).addClass('cp-hide');
                            $(colorPickerObj.nodes.HEX).addClass('cp-hide');
                            break;
                        }
                    }
                });

                if ($scope.onReady()) {
                    $scope.onReady()(colorPickerObj.color.colors);
                }
            });
        }
    };
});
